import "./style.css";

import TEETH_SVGS from "../../../../svg";
import { TEETH_SVGS_SIZE } from "../../../../helper";

const ToothSquare = ({ toothNumber, color = "", isCompleted, details }) => {
  const isStaging = process.env.REACT_APP_ENV === "staging";

  const Comp = TEETH_SVGS[toothNumber];
  const size = { height: 65, width: 65 }; // fallback
  // const size = TEETH_SVGS_SIZE[toothNumber] || { height: 80, width: 40 }; // fallback

  let filling = {
    fullTooth: isCompleted ? true : false,
    crownFilling: false,
    rootFilling: false,
  };

  const conditions = details?.conditions || [];
  if (conditions.length === 1) {
    const id = conditions[0]?.condition_identifier;

    if (id === "R-F" || id === "R-C") {
      filling.crownFilling = true;
      filling.fullTooth = false;
    } else if (id === "R-R") {
      filling.rootFilling = true;
      filling.fullTooth = false;
    }
  }
  // dont apply color for present tooth sound sub condition
  if (details?.subConditions?.length > 0) {
    if (details.subConditions[0].condition_id === 69) {
      filling.rootFilling = false;
      filling.fullTooth = false;
    }
  }

  if (!Comp) return null; // or a fallback

  return (
    <div
    // className="outer-square"
    // style={{
    //   border: isCompleted ? `1.5px solid ${color}` : "",
    // }}
    >
      {/* {!isStaging ? (
        <>
          <div className="line line-top-left"></div>
          <div className="line line-top-right"></div>
          <div className="line line-bottom-left"></div>
          <div className="line line-bottom-right"></div>
          <div className="inner-square">
            <span className="center-text">{toothNumber}</span>
          </div>
        </>
      ) : ( */}
      <Comp
        color={color}
        height={size.height}
        width={size.width}
        isCompleted={isCompleted}
        filling={filling}
      />
      {/* )} */}
    </div>
  );
};

export default ToothSquare;
